import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import {
    currentUserMeetsUserLevel,
    UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {currentUserHasAccess, PermissionName} from '@netx/core-permissions-next';

export const canAddCategories = () => {
    if (isBrandPortal()) return false;
    if (!currentUserMeetsUserLevel(UserLevel.MANAGER)) return false;

    return currentUserHasAccess(PermissionName.ADD_FOLDERS);
};
